import Link from 'next/link';
import styled from 'styled-components';

import { HeaderWrapper } from '../HeaderWrapper';

export const Wrapper = styled(HeaderWrapper)`
  display: flex;
  padding: 16px 0;
  gap: 5px;
`;

export const StyledLink = styled(Link)`
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.neutral[600]};
  color: ${({ theme: { colors } }) => colors.neutral[600]};
  text-decoration: none;
  transition: 400ms;

  &:last-child {
    overflow: hidden;
    border-bottom: none;
    color: ${({ theme: { colors } }) => colors.black};
    text-overflow: ellipsis;
    pointer-events: none;
    text-wrap: nowrap;
  }

  &:hover {
    border-bottom: 1px solid ${({ theme: { colors } }) => colors.black};
    color: ${({ theme: { colors } }) => colors.black};
    transition: 400ms;
  }
`;
